function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import round from 'lodash/round';
import compact from 'lodash/compact';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';
import VueAnalytics from 'vue-analytics';
import VueI18n from 'vue-i18n';
import defaultConfig from './config';
import utils from './utils';
import defaultComponents from './components';
import filters from './vuex/filters';
import elements from './vuex/elements';
import pagination from './vuex/pagination';
import order from './vuex/order';
import groups from './vuex/groups';
import frequency_groups from './vuex/frequency_groups';
import api from './vuex/api';
import history from './vuex/history';

function formatRegularNumber(number, locale, delimiter, separator, precision) {
  var formatter = new Intl.NumberFormat(locale, {
    style: 'decimal',
    maximumFractionDigits: precision
  });
  return formatter.formatToParts(number).map(function (_ref) {
    var type = _ref.type,
        value = _ref.value;

    switch (type) {
      case 'group':
        return delimiter;

      case 'decimal':
        return separator;

      default:
        return value;
    }
  }).reduce(function (s, p) {
    return s + p;
  });
} // Madness for 4-digit numbers.
// See Diccionario panhispánico de dudas ©2005: http://lema.rae.es/dpd/srv/search?id=QHaq7I8KrD6FQAyXTS
// RAE "explanation": https://twitter.com/RAEinforma/status/441873432519909376
// Referenced CGPM documents by RAE, which contradict RAE explanation:
// - Resolution 7 of the 9th CGPM (1948): https://www.bipm.org/en/CGPM/db/9/7/
// - Resolution 10 of the 22nd CGPM (2003) (reaffirms previous): https://www.bipm.org/en/CGPM/db/22/10/


function formatRaeNumber(number, precision) {
  if (number < -9999 || number > 9999) {
    return formatRegularNumber(number, 'es', '&nbsp;', ',', precision);
  } else {
    var _round$toString$split = round(number, precision).toString().split('.'),
        _round$toString$split2 = _slicedToArray(_round$toString$split, 2),
        integer = _round$toString$split2[0],
        decimal = _round$toString$split2[1];

    return decimal ? "".concat(integer, ",").concat(decimal) : integer;
  }
}

export var stores = {
  // The selected result type determines the behaviour and values of other modules.
  // That is why the api module should be the first one to be registered in the store.
  api: api,
  filters: filters,
  elements: elements,
  order: order,
  groups: groups,
  frequency_groups: frequency_groups,
  pagination: pagination,
  history: history
};
var gon = window.gon || {};
export default {
  install: function install(Vue, _ref2) {
    var store = _ref2.store,
        config = _ref2.config,
        components = _ref2.components,
        csvElementFields = _ref2.csvElementFields;
    this.config = utils.mergeConfig(defaultConfig, config);
    this.installVuePlugins(Vue);
    this.installVueFunctions(Vue, csvElementFields);
    this.installComponents(Vue, components);
    this.installStores(store);
  },
  installVuePlugins: function installVuePlugins(Vue) {
    Vue.use(Vuex);
    Vue.use(BootstrapVue);
    Vue.use(VueAnalytics, {
      id: gon.ga,
      disableScriptLoader: true // Script has to be loaded externally always

    });
    Vue.use(VueI18n);
    var locale = gon.i18n.locale || this.config.i18n.locale;
    this.i18n = new VueI18n({
      locale: locale,
      messages: _defineProperty({}, locale, gon.i18n.translations.ncs || this.config.i18n.translations.ncs)
    });
  },
  installVueFunctions: function installVueFunctions(Vue, csvElementFields) {
    // Converts a number to their localized form using rails number configuration.
    // It relies on VueI18n to get the locale and the number configuration.
    // Formatter is created each time, since translations can change dynamically.
    Vue.prototype.$fn = function (number) {
      var precision = parseInt(this.$tOr('number.format', 'precision', '2'));
      var delimiter = this.$tOr('number.format', 'delimiter', '.');
      var separator = this.$tOr('number.format', 'separator', ',');
      var locale = this.$i18n.locale;

      if (locale === 'es' && this.$ncsConfig.i18n.raeNumberFormat) {
        return formatRaeNumber(number, precision);
      } else {
        return formatRegularNumber(number, locale, delimiter, separator, precision);
      }
    }; // Tries to translate 'prefix.key'.
    // If translation is not found returns value.
    // If value is falsy returns key.


    Vue.prototype.$tOr = function (prefix, key, value) {
      return this.$te("".concat(prefix, ".").concat(key)) ? this.$t("".concat(prefix, ".").concat(key)) : value || key;
    }; // Used to locate index of row in the matrix for a given tag.
    // Since this list does not change, it's calculated here only once.


    Vue.prototype.$ncsTagList = this.config.tags.matrix.map(function (r) {
      return r.join('');
    }); // Returns the translation for the given tag.
    // Translations are generated automatically using tag matrix and the translation of each level.

    Vue.prototype.$tTag = function (tag) {
      var _this = this;

      var tagRow = this.$ncsConfig.tags.matrix[this.$ncsTagList.findIndex(function (t) {
        return t === tag;
      })] || []; // Per each level (column) in the row, translate the element in that level

      var translatedTag = tagRow.map(function (tag, i) {
        var category = _this.$ncsConfig.tags.categories[i];
        return _this.$tOr("tag.".concat(category.split('.').pop()), tag, null);
      });
      return compact(translatedTag).join(', ');
    };

    Vue.prototype.$ncsElementTitle = this.config.format.elementTitle;
    Vue.prototype.$ncsElementClass = this.config.format.elementClass;
    Vue.prototype.$ncsElementContent = this.config.format.elementContent;
    Vue.prototype.$ncsConfig = this.config;
    Vue.prototype.$ncsCsvElementFields = csvElementFields;
  },
  installComponents: function installComponents(Vue, components) {
    if (!components) {
      components = defaultComponents;
    }

    for (var name in components) {
      Vue.component(name, components[name]);
    }
  },
  installStores: function installStores(store) {
    if (!store) {
      store = new Vuex.Store({});
    }

    for (var module in stores) {
      store.registerModule(module, stores[module]);
    }

    for (var _module in stores) {
      store.dispatch("".concat(_module, "/reset"));
    }

    this.store = store;
  },
  utils: utils,
  defaultComponents: defaultComponents,
  defaultConfig: defaultConfig
};